import { $$ } from './shortcuts';

function initializePrint() {
  $$('[data-printbutton]').forEach(($button) => {
    $button.addEventListener('click', (e) => {
      e.preventDefault && e.preventDefault();
      window.print();
    });
  });
}

export { initializePrint };
